module.exports = __webpack_public_path__ + "img/section_card1.2cb5f9df.png";